import { useState, useEffect } from "react";
import { LeadMagnetApi } from "../../service";
import LogoFull from "../assets/LogoFull.png";
import ThankYouBg from "../assets/Home/ThankYouBg.png";
import "./LeadMagnet.css";

export default function LeadMagnetThankYou() {
  const FALLBACK_URL = "https://backend.properteasy.bitbenders.com/api/media/lead_magnets/ebooks/Properteasy_10_Hidden_Dangers_eBook.pdf";
  const [ebookUrl, setEbookUrl] = useState(FALLBACK_URL);
  const [ebookFilename, setEbookFilename] = useState("Properteasy_10_Hidden_Dangers_eBook.pdf");

  // Prevent search engine indexing
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex,nofollow";
    document.head.appendChild(meta);
    return () => document.head.removeChild(meta);
  }, []);

  useEffect(() => {
    LeadMagnetApi.getEbookUrl()
      .then((data) => {
        if (data.ebookUrl) setEbookUrl(data.ebookUrl);
        if (data.ebookFilename) setEbookFilename(data.ebookFilename);
      })
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen flex flex-col font-sans bg-white">
      {/* ── Header ── */}
      <header className="bg-white border-b border-gray-200 py-3 px-6 flex justify-center">
        <img src={LogoFull} alt="PropertEasy" className="h-14 w-auto" />
      </header>

      {/* ── Hero Section ── */}
      <section
        className="relative flex items-center justify-center px-6"
        style={{
          backgroundImage: `url(${ThankYouBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "480px",
        }}
      >
        {/* Dark overlay */}
        <div
          className="absolute inset-0"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.60)" }}
        />

        <div className="relative z-10 max-w-2xl mx-auto text-center">
          <h1
            className="mb-8"
            style={{ color: "#52C271", fontFamily: "Catamaran, sans-serif", fontSize: "48px", fontWeight: 700, lineHeight: 1.1 }}
          >
            Your E-Book Is Ready!
          </h1>

          <p
            className="text-white mb-6"
            style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif", fontSize: "28px", fontWeight: 400, lineHeight: "28px" }}
          >
            Over the next few days, we'll send additional tips, maintenance
            insights, and ways to avoid costly repairs before they happen.
          </p>

          <p
            className="text-white mb-12"
            style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif", fontSize: "28px", fontWeight: 400, lineHeight: "28px" }}
          >
            If you ever need help coordinating repairs, maintenance, or finding
            trusted local professionals, Properteasy is here to help.
          </p>

          <a
            href={ebookUrl}
            download={ebookFilename}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block text-white font-semibold px-10 py-4 rounded"
            style={{ backgroundColor: "#52C271", fontSize: "16px" }}
          >
            Download E-Book
          </a>
        </div>
      </section>
    </div>
  );
}
